// @flow
import React, { memo, type Element, useState, useEffect } from 'react';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { TimePicker } from './ComponentTypes';

type Props = Object;

const TimeField = ({ value, onChange, required, error, helperText, nullValue, ...props }: Props): Element<*> => {
  const [newError, setNewError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const isOnchange = typeof onChange === 'function';
  const newVal = `${value}:00.000Z`;
  const newDate = new Date();
  const [, time] = newDate.toISOString().split('T');
  const date = nullValue && value === '' ? null : `2000-01-01T${value === '' ? time : newVal}`;
  const [newValue, setValue] = useState(date);

  const onDateChange = e => {
    let dt = e.toISOString();
    const [HH, MM] = dt
      .split('T')[1]
      .split('.')[0]
      .split(':');
    dt = `${HH}:${MM}`;
    return isOnchange ? onChange(dt) : setValue(dt);
  };

  useEffect(() => {
    if (value) {
      setNewError(false);
      setErrorMessage('');
    }
  }, [value]);

  const handleInvalid = e => {
    e.preventDefault();
    setNewError(!e.target.validity.valid);
    setErrorMessage(e.target.validationMessage);
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <TimePicker
        {...props}
        autoOk
        inputVariant="outlined"
        margin="none"
        value={isOnchange ? date : newValue}
        onChange={onDateChange}
        mask="__:__ _M"
        placeholder="08:00 AM"
        InputLabelProps={{ classes: { focused: 'field-focused' } }}
        KeyboardButtonProps={{
          'aria-label': 'change time'
        }}
        ampm={false}
        error={error || newError}
        helperText={helperText || errorMessage}
      />
      <input required={required} value={value} style={{ display: 'none' }} onInvalid={handleInvalid} />
    </MuiPickersUtilsProvider>
  );
};

export default memo<Props>(TimeField);
